import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import URL from "@core/scripts/helper/url";
import {useQuery} from "@tanstack/react-query";

const fetchSuggestions = async (query) => {

    const absoluteUrl = URL.toAbsolute('/ajax/search/suggests/');
    const urlWithParam = URL.addUrlParam(absoluteUrl, 'query', query);
    const response = await fetchWithCSRF(urlWithParam, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    });

    if (!response.ok) {
        throw new Error('Failed to fetch suggestions');
    }

    return response.json();
};

const useSuggestions = (searchValue, {enabled = true, staleTime = 0} = {}) => {
    return useQuery({
        queryKey: ['search','suggestions', searchValue],
        enabled: enabled && searchValue.trim().length > 0,
        staleTime,
        placeholderData: (prev) => prev,
        queryFn: () => fetchSuggestions(searchValue),
    });
};
export default useSuggestions;